<template>
  <el-dialog
    v-dialogDrag
    v-dialogResize
    custom-class="merchant-view-dialog"
    title="查看商户报单（可拖拽）"
    :visible.sync="dialogVisible"
    width="50%"
    :close-on-click-modal="false"
    append-to-body
    @open="handleOpen"
    @closed="handleClosed"
  >
    <div class="container">
      <div class="fixed-cards">
        <!-- 商户报单详情的表单 -->
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>商户报单信息:</span>
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="8"><strong>客户姓名:</strong> {{ info.customName }}</el-col>
              <el-col :span="8"><strong>客户手机号:</strong> {{ info.customMobile }}</el-col>
              <el-col :span="8"><strong>客户地址:</strong> {{ info.customAddress }}</el-col>
            </el-row>
            <!-- 店铺信息：shopName、shopAddress、shopMobile -->
            <el-row>
              <el-col :span="8"><strong>店铺名称:</strong> {{ info.shopName }}</el-col>
              <el-col :span="8"><strong>店铺电话:</strong> {{ info.shopMobile }}</el-col>
              <el-col :span="8"><strong>店铺地址:</strong> {{ info.shopAddress }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="8"><strong>预计安装时间:</strong> {{ formatDate(info.installTime) }}</el-col>
              <el-col :span="8"><strong>零售价:</strong> {{ info.retailPrice }}</el-col>
              <el-col :span="8"><strong>预埋:</strong> {{ info.preEmbedded }}</el-col>
              <el-col v-if="info.lineLength" :span="8"><strong>管线预埋长度:</strong> {{ info.lineLength ? info.lineLength + '米'
                : '无' }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="8"><strong>备注:</strong> {{ info.remarks }}</el-col>
            </el-row>
          </div>
        </el-card>
      </div>

      <div class="fixed-cards">
        <!-- 商品选择表格 -->
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>商品列表:</span>
          </div>
          <div class="card-content">
            <el-table :data="selectedGoods" style="width: 100%" border>
              <el-table-column prop="name" label="商品名称">
              </el-table-column>
              <el-table-column prop="num" label="数量">
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.serviceOrderId && scope.row.serviceOrderId.length > 1">
                    <el-button v-for="(id, index) in scope.row.serviceOrderId" :key="index" :disabled="!id" type="text"
                      icon="el-icon-view" @click="viewWorkOrder({ serviceOrderId: id })" style="margin-top: 10px;">
                      工单{{ index + 1 }}
                    </el-button>
                  </div>
                  <div v-else>
                    <el-button :disabled="!scope.row.serviceOrderId" type="text" icon="el-icon-view"
                      @click="viewWorkOrder(scope.row)" style="margin-top: 10px;">
                      工单
                    </el-button>
                  </div>
                  <el-button :disabled="!scope.row.serviceOrderId" type="text" icon="el-icon-view"
                    @click="viewEvaluation(scope.row.viewEvaluatId)" style="margin-top: 10px;">
                    查看评价
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
        <viewOrder :visibleOrder.sync="viewOrderVisible" :orderId="orderId" :evaluateInfo="evaluateInfo" />
        <engineer-details :visible.sync="engineerDetailsVisible" :goods-id="engineerGoodsId" />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="small" @click="handleClose" icon="el-icon-circle-close-outline">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getMerchantOrder, getGoodList } from "@/api/work/waterProject/merchants";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import viewOrder from "./components/viewOrder.vue";
import EngineerDetails from "../engineer/engineerDetails/dialog.vue";
export default {
  components: {
    viewOrder,
    EngineerDetails,
  },
  directives: {
    // el-dialog 可拖拽指令：按住头部拖动，限制在视口内
    dialogDrag: {
      bind(el) {
        const dialogHeaderEl = el.querySelector('.el-dialog__header');
        const dragDom = el.querySelector('.el-dialog');
        if (!dialogHeaderEl || !dragDom) return;

        dialogHeaderEl.onmousedown = (e) => {
          // 首次拖拽前，将弹窗转为绝对定位并保留当前视觉位置（初始为 flex 居中）
          if (dragDom.style.position !== 'absolute') {
            const rect = dragDom.getBoundingClientRect();
            dragDom.style.position = 'absolute';
            dragDom.style.margin = '0';
            dragDom.style.left = rect.left + 'px';
            dragDom.style.top = rect.top + 'px';
          }
          const disX = e.clientX - dialogHeaderEl.offsetLeft;
          const disY = e.clientY - dialogHeaderEl.offsetTop;
          const dragDomWidth = dragDom.offsetWidth;
          const dragDomHeight = dragDom.offsetHeight;
          const screenWidth = document.documentElement.clientWidth;
          const screenHeight = document.documentElement.clientHeight;
          const minDragDomLeft = dragDom.offsetLeft;
          const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
          const minDragDomTop = dragDom.offsetTop;
          const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight;
          const styL = getComputedStyle(dragDom).left;
          const styT = getComputedStyle(dragDom).top;
          let left = styL.includes('%')
            ? +document.body.clientWidth * (+styL.replace(/%/g, '') / 100)
            : +styL.replace(/px/g, '');
          let top = styT.includes('%')
            ? +document.body.clientHeight * (+styT.replace(/%/g, '') / 100)
            : +styT.replace(/px/g, '');

          document.onmousemove = (ev) => {
            let moveLeft = ev.clientX - disX;
            let moveTop = ev.clientY - disY;
            if (-moveLeft > minDragDomLeft) moveLeft = -minDragDomLeft;
            else if (moveLeft > maxDragDomLeft) moveLeft = maxDragDomLeft;
            if (-moveTop > minDragDomTop) moveTop = -minDragDomTop;
            else if (moveTop > maxDragDomTop) moveTop = maxDragDomTop;
            dragDom.style.cssText += `;left:${moveLeft + left}px;top:${moveTop + top}px;`;
          };
          document.onmouseup = () => {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      },
    },
    // el-dialog 可缩放指令：鼠标移到边缘/四角时拖拽改变尺寸
    dialogResize: {
      bind(el) {
        const dragDom = el.querySelector('.el-dialog');
        const dialogHeaderEl = el.querySelector('.el-dialog__header');
        if (!dragDom) return;
        const EDGE = 8; // 边缘热区宽度
        const cursorMap = {
          top: 'ns-resize',
          bottom: 'ns-resize',
          left: 'ew-resize',
          right: 'ew-resize',
          'top-left': 'nwse-resize',
          'bottom-right': 'nwse-resize',
          'top-right': 'nesw-resize',
          'bottom-left': 'nesw-resize',
        };
        const getDirection = (e) => {
          const rect = dragDom.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          if (x < 0 || y < 0 || x > rect.width || y > rect.height) return '';
          const top = y < EDGE;
          const bottom = y > rect.height - EDGE;
          const left = x < EDGE;
          const right = x > rect.width - EDGE;
          if (top && left) return 'top-left';
          if (top && right) return 'top-right';
          if (bottom && left) return 'bottom-left';
          if (bottom && right) return 'bottom-right';
          if (top) return 'top';
          if (bottom) return 'bottom';
          if (left) return 'left';
          if (right) return 'right';
          return '';
        };

        // 鼠标移动时动态设置 cursor：边缘显示缩放指针，头部显示 move
        dragDom.addEventListener('mousemove', (e) => {
          if (document._isDialogResizing) return;
          const dir = getDirection(e);
          if (dir) {
            dragDom.style.cursor = cursorMap[dir];
            if (dialogHeaderEl) dialogHeaderEl.style.cursor = cursorMap[dir];
          } else if (dialogHeaderEl && dialogHeaderEl.contains(e.target)) {
            dialogHeaderEl.style.cursor = 'move';
            dragDom.style.cursor = '';
          } else {
            dragDom.style.cursor = '';
            if (dialogHeaderEl) dialogHeaderEl.style.cursor = '';
          }
        });

        // 在 capture 阶段拦截 mousedown，边缘命中则启动缩放，避免触发头部拖拽逻辑
        dragDom.addEventListener(
          'mousedown',
          (e) => {
            const dir = getDirection(e);
            if (!dir) return;
            e.stopPropagation();
            e.preventDefault();
            document._isDialogResizing = true;
            const rect = dragDom.getBoundingClientRect();
            // 首次缩放前，转为绝对定位并保留当前位置/尺寸
            if (dragDom.style.position !== 'absolute') {
              dragDom.style.position = 'absolute';
              dragDom.style.margin = '0';
              dragDom.style.left = rect.left + 'px';
              dragDom.style.top = rect.top + 'px';
            }
            const startX = e.clientX;
            const startY = e.clientY;
            const startW = rect.width;
            const startH = rect.height;
            const startL = rect.left;
            const startT = rect.top;
            const minW = 320;
            const minH = 200;
            const screenW = document.documentElement.clientWidth;
            const screenH = document.documentElement.clientHeight;

            document.onmousemove = (ev) => {
              const dx = ev.clientX - startX;
              const dy = ev.clientY - startY;
              let newW = startW;
              let newH = startH;
              let newL = startL;
              let newT = startT;
              if (dir.indexOf('right') >= 0) {
                newW = Math.max(minW, Math.min(startW + dx, screenW - startL));
              }
              if (dir.indexOf('bottom') >= 0) {
                newH = Math.max(minH, Math.min(startH + dy, screenH - startT));
              }
              if (dir.indexOf('left') >= 0) {
                newW = Math.max(minW, Math.min(startW - dx, startL + startW));
                newL = startL + (startW - newW);
              }
              if (dir.indexOf('top') >= 0) {
                newH = Math.max(minH, Math.min(startH - dy, startT + startH));
                newT = startT + (startH - newH);
              }
              dragDom.style.width = newW + 'px';
              dragDom.style.height = newH + 'px';
              dragDom.style.left = newL + 'px';
              dragDom.style.top = newT + 'px';
            };
            document.onmouseup = () => {
              document._isDialogResizing = false;
              document.onmousemove = null;
              document.onmouseup = null;
            };
          },
          true
        );
      },
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      goodsList: [], // 商品列表
      selectedGoods: [], // 用户选择的商品
      info: {
        installTime: null,
      }, // 表单数据
      isFormReadOnly: true, // 整个表单是否只读
      viewOrderVisible: false,
      orderId: "",
      evaluateInfo: false,
      // 嵌套工单详情弹窗
      engineerDetailsVisible: false,
      engineerGoodsId: "",
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    handleOpen() {
      this.loadData();
      this.$nextTick(() => {
        // 弹窗水平垂直居中：给外层 wrapper 套 flex
        const dialog = document.querySelector('.merchant-view-dialog');
        if (dialog) {
          const wrapper = dialog.parentElement;
          if (wrapper && wrapper.classList.contains('el-dialog__wrapper')) {
            wrapper.style.display = 'flex';
            wrapper.style.alignItems = 'center';
            wrapper.style.justifyContent = 'center';
          }
          // 纯弹窗位置状态（避免上次拖拽/缩放遗留的 inline style 影响居中）
          dialog.style.position = '';
          dialog.style.left = '';
          dialog.style.top = '';
          dialog.style.margin = '0';
          dialog.style.width = '';
          dialog.style.height = '';
          dialog.style.cursor = '';
        }
        // 蒙层透明度调为 0.1，方便连同后面的列表一起截图
        const modal = document.querySelector('.v-modal');
        if (modal) {
          this._originalModalOpacity = modal.style.opacity;
          modal.style.opacity = '0.1';
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClosed() {
      // 弹窗完全关闭后恢复蒙层透明度
      const modal = document.querySelector('.v-modal');
      if (modal) {
        modal.style.opacity = this._originalModalOpacity || '';
      }
    },
    loadData() {
      const id = this.id;
      this.info = { installTime: null };
      this.selectedGoods = [];
      if (!id) return;
      getMerchantOrder(id).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = data;
          this.info.picUrl = data.picUrl || [];
          if (data.list && data.list.length > 0) {
            this.processSelectedGoods(data.list);
          } else {
            getGoodList(id).then(res => {
              if (res.code === '200') {
                const goodsData = JSON.parse(res.data);
                this.selectedGoods = goodsData;
                this.processSelectedGoods(goodsData);
              } else {
                this.$message.error('获取商品列表失败');
                this.processSelectedGoods([]);
              }
            }).catch(() => {
              this.$message.error('获取商品列表接口调用失败');
              this.processSelectedGoods([]);
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    viewEvaluation(id) {
      this.viewOrderVisible = true;
      this.orderId = id;
      this.evaluateInfo = true;
    },
    // 处理安装时间变更
    handleInstallTimeChange(value) {
      if (value) {
        const timestamp = new Date(value).getTime();
        this.info.installTime = timestamp;
      } else {
        this.info.installTime = null;
      }
    },
    // 处理商品列表并回显
    processSelectedGoods(selectedGoods) {
      const type = 'PURE_WATER'
      findPureWaterGoodsByRootDepartId(type).then(res => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          if (data) {
            this.goodsList = data;
            if (Array.isArray(selectedGoods)) {
              this.selectedGoods = selectedGoods.map(item => ({
                goodsId: item.goodsId,
                num: item.num,
                serviceOrderId: item.serviceOrderId ? item.serviceOrderId.split(',') : item.serviceOrderId,
                viewEvaluatId: item.deliveryOrder ? item.deliveryOrder.id : null,
                declarationId: item.declarationId || '',
                name: this.goodsList.find(g => g.id == item.goodsId) ? this.goodsList.find(g => g.id == item.goodsId).name : ""
              }));
            } else {
              this.selectedGoods = [];
              this.goodsList = [];
            }
          } else {
            this.goodsList = [];
            this.selectedGoods = [];
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    viewWorkOrder(row) {
      this.engineerGoodsId = row.serviceOrderId;
      this.engineerDetailsVisible = true;
    },
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
  font-family: fangsong;
  font-size: large;
}

.fixed-cards {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.card {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-content {
  padding: 20px;
}

.el-table {
  font-family: fangsong;
  font-weight: bold;
  font-size: large;
}

.el-table th,
.el-table td {
  font-family: fangsong;
  font-size: large;
}

.el-table th {
  font-family: fangsong;
  font-size: large;
}
</style>

<style>
/* 限制弹窗最大高度，避免内容擑高超出视口。并使 body 内部滚动 */
.merchant-view-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.merchant-view-dialog .el-dialog__body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
